import axios from 'axios';
import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin';
window.gsap = gsap;
gsap.registerPlugin(ScrollToPlugin);

let url = new URL(window.location, 'https://ct.co.uk');

// init insights slider
const insightsSlider = new Swiper('.insights__slider .swiper', {
	modules: [Navigation, Pagination],
	autoHeight: true,
	slidesPerView: 1,
	spaceBetween: 30,
	navigation: {
		nextEl: '.insights__slider-nav .swiper__next',
		prevEl: '.insights__slider-nav .swiper__prev',
	},
	pagination: {
		el: document.querySelector('.insights__slider').querySelector('.swiper-pagination'),
		type: 'progressbar',
	},
	breakpoints: {
		600: {
			slidesPerView: 2,
			spaceBetween: 30,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 40,
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 40,
		}
	}
});

// filter dropdown
const filterDropdown = document.querySelectorAll('.filter-dropdown');
const postsFilter = document.querySelector('#posts-filter');
let postsPage = 1;

if (filterDropdown) {
	filterDropdown.forEach((filter) => {
		let currentFilter = filter.querySelector('.filter-dropdown__current');
		let currentFilterSlug = currentFilter.getAttribute('data-filter');
		let filterItems = filter.querySelectorAll('.menu-item');
		// add selected class
		filter.querySelector(`.menu-item[data-filter="${currentFilterSlug}"]`).classList.add('selected');
		// open menu and close menu if click outside filter el
		currentFilter.addEventListener('click', (event) => {
			filter.classList.add('active');
		});
		let filterListener = function(event) {
			closeFilterDropdown(event, filter, filterListener);
		}
		document.addEventListener('click', filterListener, true);
		// update dropdown with new selected filter and close menu
		filterItems.forEach((item) => {
			item.addEventListener('click', (event) => {
				let newFilterSlug = item.getAttribute('data-filter');
				let newFilterName = item.textContent;
				currentFilter.setAttribute('data-filter', newFilterSlug);
				currentFilter.querySelector('span').textContent = newFilterName;
				filter.querySelector('.menu-item.selected').classList.remove('selected');
				item.classList.add('selected');
				filter.classList.remove('active');
				// filter insights
				if (filter.classList.contains('filter-dropdown--insights')) {
					insightsFilter(insightsSlider, item);
				}
				// filter news posts
				else {
					document.querySelector('input[name="posts_category"]').value = newFilterSlug;
					postsPage = 1;
					postsFilterSubmit();
				}
			});
		});
	});
}

// filter insights by url
const insightsFilterLinks = document.querySelectorAll('.menu-item--insights-filter a');
const insightsFilterDropdown = document.querySelector('.filter-dropdown--insights');
let currentFilter = insightsFilterDropdown.querySelector('.filter-dropdown__current');

// force reload if filter links are clicked
if (insightsFilterLinks) {
	insightsFilterLinks.forEach((item) => {
		item.addEventListener('click', (event) => {
			setTimeout(() => {
				location.reload();
			}, 100);
		});
	});
}
// update insights filter
if (insightsFilterDropdown && url.hash.includes('#insights-')) {
	// setup vars to filter insight slider
	let urlInsightsFilter = url.hash.replace('#insights-', '');
	let newInsightsFilter = insightsFilterDropdown.querySelector(`.menu-item[data-filter="${urlInsightsFilter}"]`);
	// update filter dropdown
	let newFilterSlug = newInsightsFilter.getAttribute('data-filter');
	let newFilterName = newInsightsFilter.textContent;
	currentFilter.setAttribute('data-filter', newFilterSlug);
	currentFilter.querySelector('span').textContent = newFilterName;
	insightsFilterDropdown.querySelector('.menu-item.selected').classList.remove('selected');
	newInsightsFilter.classList.add('selected');
	insightsFilter(insightsSlider, newInsightsFilter);
	// scroll to insights slider
	gsap.to(window, {duration: 0.7, scrollTo: {y: '.insights', offsetY: 100}, ease: 'sine.out'});
}

// close filter dropdown when clicking outside
function closeFilterDropdown(event, filter, filterListener) {
	let targetEl = event.target;
	do {
		if (targetEl == filter) {
			// console.log('Clicked inside!');
			return;
		}
		// Go up the DOM
		targetEl = targetEl.parentNode;
	}
	while (targetEl);
	// console.log('Clicked outside!');
	filter.classList.remove('active');
	// document.removeEventListener('click', filterListener, true);
}

// insights filter
function insightsFilter(swiper, filter) {
	// check for hidden slides and add back into slider if they match selected filter
	let swiperHiddenSlides = swiper.wrapperEl.querySelectorAll('.non-swiper-slide');
	if (swiperHiddenSlides) {
		swiperHiddenSlides.forEach((slide) => {
			if (slide.getAttribute('data-category') == filter.getAttribute('data-filter') || filter.getAttribute('data-filter') == 'all') {
				slide.classList.remove('non-swiper-slide');
				slide.classList.add('swiper-slide');
				slide.style.display = 'initial';
			}
		});
	}
	// hide slides that don't match selected filter
	swiper.slides.forEach((slide) => {
		if (filter.getAttribute('data-filter') == 'all') {
			// do nothing
		} else if (slide.getAttribute('data-category') != filter.getAttribute('data-filter')) {
			slide.classList.remove('swiper-slide');
			slide.classList.add('non-swiper-slide');
			slide.style.display = 'none';
		}
	});
	swiper.update();
	swiper.slideTo(0);
}

// load more news posts
let loadmore = document.querySelector('.load-more-posts');
if (loadmore) {
	loadmore.addEventListener('click', (event) => {
		event.preventDefault();
		postsPage++;
		postsFilterSubmit(postsPage, true);
	});
}

// ajax to retrieve filtered news posts
let loader = document.createElement('div');
loader.className = 'lds-ellipsis';
loader.appendChild(document.createElement('div'));
loader.appendChild(document.createElement('div'));
loader.appendChild(document.createElement('div'));
loader.appendChild(document.createElement('div'));	
function postsFilterSubmit(paged = 1, loadmore_posts = false) {
	let formData = new FormData(postsFilter);
	let ajaxEl = postsFilter;
	let ajaxLoaderEl = postsFilter.querySelector('.filter-dropdown__current');
	if (loadmore_posts) {
		ajaxEl = loadmore;
		ajaxLoaderEl = loadmore;
	}
	ajaxEl.classList.add('ajaxing');
	ajaxLoaderEl.append(loader);
	formData.append('action', 'posts_filter');
	formData.append('paged', paged);
	// form ajax
	axios.post( ajaxurl, formData )
	.then( response => {
		// console.log(response);
		// remove ajax and loader
		ajaxEl.classList.remove('ajaxing');
		loader.remove();
		if (loadmore) {
			if (response.data.last_page || response.data.no_posts) {
				loadmore.remove();
			} else {
				document.querySelector('.pagination').append(loadmore);
			}
		}
		if (loadmore_posts) {
			document.querySelector('.news__grid').insertAdjacentHTML('beforeend', response.data.posts);
		} else {
			document.querySelector('.news__grid').innerHTML = response.data.posts;
		}
	})
	.catch( error => {
		console.log(error);
		ajaxEl.classList.remove('ajaxing');
	})
}
